<template>
  <div class="media d-flex">
    <div
      v-if="$slots.aside"
      class="media-aside mr-1 d-flex align-items-start"
    >
      <slot name="aside" />
    </div>
    <div class="media-body flex-grow-1">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BMedia',
  props: {
    noBody: { type: Boolean, default: false },
    verticalAlign: { type: String, default: 'top' },
  },
}
</script>
